import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';  
import Preloader from './Components/Preloader';
import ScrollTopBtn from './Components/ScrollTopBtn';
import AboutPage from './pages/AboutPage';
import ServicePage from './pages/ServicePage';
import HomeOne from './pages/HomeOne';
import HomeTwo from './pages/HomeTwo';
import News from './pages/News';
import NewsDetails from './pages/NewsDetails';

import TeamPage from './pages/TeamPage';
import FaqPage from './pages/FaqPage';
import PricingPage from './pages/PricingPage';
import ServiceDetails from './pages/ServiceDetails';
import HomeThree from './pages/HomeThree';
import HomeFour from './pages/HomeFour';
import ProjectPage from './pages/ProjectPage';
import ContactPage from './pages/ContactPage';
import Layout from './Layout';
import History from './pages/History';
import VisonMison from './pages/VisonMison';
import CorporateValue from './pages/CorporateValue';
import Warehouse from './pages/warehouse';
import Rawcotton from './pages/Rawcotton';
import Companyprofile from './pages/companyprofile';
import Chairmain from './pages/Chairmain';
import Management from './pages/Management';
import AccreditationRecongnition from './pages/AccreditationRecongnition';
import Memberships from './pages/Memberships';
import ConsumerEdibleOils from './pages/ConsumerEdibleOils';
import CommercialOils from './pages/CommercialOils';
import OilCakes from './pages/OilCakes';
import OilMeals from './pages/OilMeals';
import Seeds from './pages/Seeds';
import CottonYarns from './pages/CottonYarns';
import Clients from './pages/Clients';
import Inquiry from './pages/Inquiry';
import GalleryShowcase from './pages/GalleryShowcase';
import Blogs from './pages/Blogs';
import OutletPage from './pages/OutletPage';
 

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer); // Clean up timer on unmount
  }, []);

  if (loading) return <Preloader />;

  return (
    <>
      <ScrollTopBtn />
      <Layout >
      <Routes>
        
          <Route path="/" element={<HomeTwo />} />
          <Route path="/home-one" element={<HomeOne />} />
          <Route path="/home-two" element={<HomeTwo />} />
          <Route path="/home-three" element={<HomeThree />} />
          <Route path="/home-four" element={<HomeFour />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicePage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/news" element={<News />} />
          <Route path="/news-details" element={<NewsDetails />} />
          <Route path="/blog/:blogUrl" element={<ServiceDetails />} />
          <Route path="/products" element={<ProjectPage />} />
          <Route path="/history" element={<History />} />
          <Route path="/misson_vision" element={<VisonMison />} />
          <Route path="/Corporate_Value" element={<CorporateValue />} />
          <Route path="/warehouse" element={<Warehouse />} />
          <Route path="/raw_cotton" element={<Rawcotton />} />
          <Route path="/ConsumerEdibleOils" element={<ConsumerEdibleOils/>} />
          <Route path="/companyprofile" element={<Companyprofile />} />
          <Route path="/CommercialOils" element={<CommercialOils />} />
          <Route path="/OilCakes" element={<OilCakes />} />
          <Route path="/OilMeals" element={<OilMeals />} />
          <Route path="/Seeds" element={<Seeds />} />
          <Route path="/CottonYarns" element={<CottonYarns />} />
          <Route path="/Chairmain" element={<Chairmain />} />
          <Route path="/Management" element={<Management />} />
          <Route path="/acc_nd_rec" element={<AccreditationRecongnition />} />
          <Route path="/Memberships" element={<Memberships />} />
          <Route path="/Clients" element={<Clients />} />
          <Route path="/Inquiry" element={<Inquiry />} />
          <Route path="/Gallery" element={<GalleryShowcase />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/Outlet" element={<OutletPage />} />
      
        
      </Routes>
      </Layout>
    </>
  );
};

export default App;
